/* AlignaFit adaptive chat (05 Oct 2026): while the mobile sticky "Add to cart" bar is on screen,
   flag body.sticky-atc-active and publish the lift the chat needs (--af-atc-lift = bar height − 50px,
   so the chat bubble always clears the bar with a small gap, whatever the bar's height on that phone). */
(function () {
  function setup() {
    var bar = document.querySelector('sticky-atc');
    if (!bar) return;
    function lift() {
      var h = bar.getBoundingClientRect().height || 0;
      document.body.style.setProperty('--af-atc-lift', Math.max(0, Math.round(h - 50)) + 'px');
    }
    var obs = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      if (visible) lift();
      document.body.classList.toggle('sticky-atc-active', visible);
    }, { threshold: 0.01 });
    obs.observe(bar);
    window.addEventListener('resize', lift);
    lift();
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', setup) : setup();
})();
